module.exports = __webpack_public_path__ + "static/measure-a66578359b8e3cd37de2a61ec750f395.svg";